/* eslint-disable object-shorthand */
import { useSelector } from 'react-redux';
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { useFetchLoggedUser } from '@/services/hooks';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const owner = queryKey[2];
  const pageNumber = queryKey[3];
  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_all_invoices?owner=${owner}&page_number=${pageNumber}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchInvoices = (pageNumber: number) => {
  const { url } = useSelector(selectAuth);
  const { data } = useFetchLoggedUser();

  return useQuery(['invoices', url, data, pageNumber], fetcher, {
    enabled: !!data,
  });
};
